module.exports = "<template>\r\n    <div ref=\"calendar\" show.bind=\"open\"></div>\r\n</template>";